import { Component, inject, Input, OnInit } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { NgCircleProgressModule } from 'ng-circle-progress';
import {
  getHorlogeTotalTime,
  transformWeltico2BufferToModel,
  transformWeltico2ModelToBuffer,
  transformWeltico2WeekModelToBuffer,
  transformWelticoWeekBufferToModel,
  Weltico2HorlogeModel,
} from '../../../services/ecosystems/helper/horloge';
import { convertMinutesToTime } from '../../../services/ecosystems/helper/convertSecondsToTime';
import Moment from 'moment/moment';
import moment from 'moment/moment';
import {
  weltico2BlancType,
  weltico2CouleurType,
} from '../function-parameters-settings-weltico2-clock-screen/function-parameters-settings-weltico2-clock-screen.component';
import { AppComponent } from '../../../app.component';

@Component({
  selector: 'app-function-parameters-setting-weltico2-clock-week-screen',
  templateUrl:
    './function-parameters-setting-weltico2-clock-week-screen.component.html',
  styleUrls: [
    './function-parameters-setting-weltico2-clock-week-screen.component.scss',
  ],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    IonFooter,
    NgCircleProgressModule,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
  ],
})
export class FunctionParametersSettingWeltico2ClockWeekScreenComponent
  implements OnInit
{
  private modalController = inject(ModalController);

  @Input() value: string = '';
  public valueResult: string = '';
  @Input() welticoColors: any = weltico2CouleurType;
  @Input() colorType: number = 3;

  public horlogesModel: any = [];
  public selectModel: Weltico2HorlogeModel | null = null;
  public selectModelStep: number = 0;

  isModalOpen = false;

  constructor() {}

  public list: any = [];
  public minuteInterval: number = 60;

  getWelticoColor(color: number): any {
    let selectedColor = null;
    this.welticoColors.map((d: any) => {
      d.colors.map((colors: any, index: any) => {
        colors.map((c: any) => {
          if (c.code === color) {
            selectedColor = c;
          }
        });
      });
    });
    return selectedColor;
  }

  ngOnInit() {
    for (let i = 0; i < 60 * 24; i = i + this.minuteInterval) {
      this.list.push({ label: convertMinutesToTime(i), ref: i * 60 });
    }

    this.valueResult = this.value;

    if (this.colorType === 3) {
      this.welticoColors = weltico2CouleurType;
    } else {
      this.welticoColors = weltico2BlancType;
    }

    this.horlogesModel = transformWeltico2BufferToModel(this.valueResult);
  }

  onCloseSelectTimeIntervalChoice(
    ref: number,
    startDate: number,
    endDate: number,
    color: number,
  ) {
    this.isModalOpen = false;

    if (ref == -1) {
      this.horlogesModel.push({
        ref: this.horlogesModel.length + 1,
        start: startDate,
        end: endDate,
        color,
      });
    } else {
      for (let i = 0; i < this.horlogesModel.length; i++) {
        if (this.horlogesModel[i].ref == ref) {
          this.horlogesModel[i].start = startDate;
          this.horlogesModel[i].end = endDate;
          this.horlogesModel[i].color = color;
        }
      }
    }

    const buf = transformWeltico2ModelToBuffer(this.horlogesModel);
    this.valueResult = buf;
    this.horlogesModel = transformWeltico2BufferToModel(buf);
  }

  secondeToHourMinute(time: number) {
    let h = Math.floor(time / (60 * 60));
    let m = Math.floor((time - h * 3600) / 60);

    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
  }

  tempsTotal() {
    const time = getHorlogeTotalTime(this.horlogesModel);
    return this.secondeToHourMinute(time);
  }

  onCloseSelectTimeIntervalRemove(ref: number) {
    for (let i = 0; i < this.horlogesModel.length; i++) {
      if (this.horlogesModel[i].ref == ref) {
        this.horlogesModel.splice(i, 1);

        const buf = transformWeltico2ModelToBuffer(this.horlogesModel);
        this.valueResult = buf;
        this.horlogesModel = transformWeltico2BufferToModel(buf);
        break;
      }
    }

    this.isModalOpen = false;
  }

  transformNumberToDegree(num: number) {
    return (num * 360) / (60 * 60 * 24);
  }

  selectColor(value: number) {
    this.selectModel!.color = value;
  }

  nextStep() {
    this.selectModelStep = this.selectModelStep + 1;
  }

  goToStep(step: number) {
    this.selectModelStep = step;
  }

  selectStart(value: number) {
    this.selectModel!.start = value;
  }

  selectEnd(value: number) {
    this.selectModel!.end = value;
  }

  openModal(selectModel: Weltico2HorlogeModel | null = null) {
    if (selectModel == null) {
      let hourStr = Moment().format('HH');
      this.selectModelStep = 0;
      this.selectModel = {
        ref: -1,
        start: parseInt(hourStr) * 3600,
        end: ((parseInt(hourStr) + 1) % 24) * 3600,
        color: 0,
      };
    } else {
      this.selectModel = JSON.parse(JSON.stringify(selectModel));
      this.selectModelStep = 3;
    }

    console.log(this.selectModel);
    this.isModalOpen = true;
  }

  deleteModel() {
    this.onCloseSelectTimeIntervalRemove(this.selectModel!.ref);
  }

  saveModel() {
    this.onCloseSelectTimeIntervalChoice(
      this.selectModel!.ref,
      this.selectModel!.start,
      this.selectModel!.end,
      this.selectModel!.color,
    );
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectModel = null;
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss({ value: this.valueResult });
  }

  getStartDate() {
    return moment.utc(this.selectModel!.start! * 1000).format('HH:mm');
  }
  getEndDate() {
    return moment.utc(this.selectModel!.end! * 1000).format('HH:mm');
  }

  protected readonly AppComponent = AppComponent;
}
